export const languages = ["nb-NO", "en-US"];
